<template>
    <suspense>
        <DxMenu :data-source="appList" item-template="itemTemplate" @item-click="onAppMenuItemClick">
            <template #itemTemplate="{ data }">
                <div :class="appMenuStyleClasses(data.id, !!data.items)">
                    <component :is="appSvgArr[data.id]" class="ai-svg-color ai-top-menu-item-app-switcher-svg" />
                    <span>{{ data.name }}</span>
                </div>
            </template>
        </DxMenu>
    </suspense>
</template>

<script>
export default {
    name: 'top-menu-app-switcher',
};
</script>

<script setup>
import { onMounted, ref } from 'vue';
import { DxMenu } from 'devextreme-vue/menu';
import { useRouter } from 'vue-router';
import { getCookie, setCookie } from '@/utils/cookies';
import { getOpenedTabs, saveTabContent } from '../navigation-bars-data';
import { processTab } from './utils';
import AiCustomConfirmDialog from '@/utils/ai-custom-confirm-dialog';
import { setSaveUserDataPopupVisible } from '../../main-layout-data';

const props = defineProps({
    appSvgArr: {
        type: Object,
        default: () => {
            return {};
        },
    },
    userApps: {
        type: Array,
        default: () => [],
    },
});

//
const selectedApp = ref(new Map());

const disabled = (id, hasItems) => +getCookie('app') === id && !hasItems;

const appMenuStyleClasses = (id, hasItems) => ({
    'flex gap-2': true,
    'opacity-50': disabled(id, hasItems),
});

const appList = ref([]);

onMounted(async () => {
    const currentAppId = +getCookie('app');
    const currentApp = props.userApps.find(app => +currentAppId === app.kod_app);
    if (currentApp) {
        appList.value = [
            {
                id: currentApp.kod_app,
                name: currentApp.name_app,
                items: props.userApps.map(app => ({
                    id: app.kod_app,
                    name: app.name_app,
                })),
            },
        ];
    }
});

const changeApp = (eventData, currentLogin) => {
    setCookie('app', eventData.id);
    selectedApp.value.set(currentLogin, eventData.id);
    setCookie('selectedApp', JSON.stringify(Array.from(selectedApp.value.entries())));
    router.push({ name: 'AppDepartmentSelect' });
};

const router = useRouter();
const onAppMenuItemClick = async event => {
    const currentAppId = +getCookie('app');
    const currentLogin = getCookie('login');

    if (currentAppId !== event.itemData.id) {
        const dirtyTabs = getOpenedTabs().filter(tab => tab.isDirty);

        if (dirtyTabs.length) {
            const result = await AiCustomConfirmDialog(
                'В закрывающихся вкладках есть несохраненные изменения. Сохранить изменения?'
            );

            let resultInsideCase;

            switch (result) {
                case 1:
                    setSaveUserDataPopupVisible(true);
                    resultInsideCase = await processTab(dirtyTabs[0], 0, dirtyTabs, saveTabContent);
                    setSaveUserDataPopupVisible(false);
                    if (resultInsideCase) {
                        changeApp(event.itemData, currentLogin);
                    }
                    break;
                case -1:
                    break;
                case 0:
                    changeApp(event.itemData, currentLogin);
            }
        } else {
            changeApp(event.itemData, currentLogin);
        }
    }
};
</script>

<style lang="scss" scoped>
.ai-top-menu-item-app-switcher-svg {
    padding-top: 2px;
}
</style>
